import { useAuth } from '../auth'
import { AuthLayout } from '../components/AuthLayout'
import { SignInMethods } from '../components/SignInMethods'
import { navigate, safeReturnUrl, useRoute } from '../router'

/** The sign-in page. Goes back to `returnUrl` afterwards, which is where a protected page sent us from. */
export function LoginPage({ returnUrl }: { returnUrl?: string }) {
  const route = useRoute()
  const { providers, setUser } = useAuth()
  const target = safeReturnUrl(returnUrl ?? route.query.get('returnUrl'))
  const initialError = route.query.get('error')

  return (
    <AuthLayout
      title="One account for every Relatude.DB installation."
      lead="Relatude.License issues the licenses that Relatude.DB runs under, and is the sign-in its administrators use. Manage licenses and API keys here, decide which installations may be signed in to and by whom, and carry one passkey to all of them."
      points={[
        {
          icon: 'key',
          title: 'Licenses and keys',
          text: 'Issue a license, take its keys to the installation, and rotate an API key whenever you need to.',
        },
        {
          icon: 'shield',
          title: 'Installations under your control',
          text: 'Every installation, and every address it is opened on, is approved by you before anyone signs in through it.',
        },
        {
          icon: 'users',
          title: 'No passwords',
          text: 'Sign in with a Google or Microsoft account, a passkey, or a code by SMS. A passkey cannot be phished or guessed.',
        },
      ]}
    >
      <h1 className="panel-title">Sign in</h1>
      <p className="panel-lead">Use any of the ways below. The first one you use makes your account; the others can be linked to it later.</p>
      <SignInMethods
        providers={providers}
        returnUrl={target}
        initialError={initialError}
        onSignedIn={(result) => {
          setUser(result.user)
          navigate(target, true)
        }}
      />
    </AuthLayout>
  )
}
